<div *ngIf="showComponents">
    <data-sharing-message></data-sharing-message>
</div>
